<template>
  <base-popup
    v-model="dialog"
    title="Добавить стандарты оснащения"
    :icon="UtilGetIcon('view-EquipmentStandarts')"
    :width="width"
    :height="height"
    @save="$emit('save', selected)"
  >
    <base-list-view
      :headers="headers"
      :dataSource="dataSource"
      :showDelete="false"
      :notShowActions="['add']"
      :search.sync="search"
      title="Стандарты оснащения"
      @input="(value) => (this.selected = value)"
      @onRefresh="init"
      :sort-by="['Profile', 'Name']"
    ></base-list-view>
  </base-popup>
</template>

<script>
import EquipmentStandartsService from "../../services/EquipmentStandartsService";
import ListEditMixin from "../../mixins/ListEditMixin";
import BasePopup from "../../layouts/BasePopup.vue";
import BaseListView from "../../layouts/BaseListView.vue";

export default {
  name: "view-EquipmentStandartsSelect",
  components: { BasePopup, BaseListView },
  mixins: [ListEditMixin],
  props: {
    value: Boolean,
    filter: Array,
    width: String,
    height: String,
  },
  data: () => {
    return {
      loading: true,
      headers: [
        { text: "Название", value: "Name" },
        {
          text: "Профиль",
          value: "Profile",
          dataType: "object",
          displayText: (p) => p?.Name,
        },
        { text: "Нормативный документ", value: "NormativeDocument" },
      ],
      apiService: EquipmentStandartsService,
      source: null,
      dataSource: [],
      selected: [],
      search: "",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.search = null;
        this.$emit("input", value);
      },
    },
  },
  watch: {
    filter: function () {
      if (this.source) this.setFilter();
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    DataFromServerNormalize(data) {
      this.source = data;
      this.setFilter();
      return this.dataSource;
    },
    setFilter() {
      if (this.filter?.length)
        this.dataSource = this.source.filter(
          (item) => this.filter.indexOf(item.Id) === -1
        );
      else this.dataSource = this.source;
    },
  },
};
</script>
